<template>
  <f7-page name="index">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>
        <!-- 若是有分店則套用 navbar-center -->
        <navbar-center :title="storeName" :subtitle="storeBranch" v-if="storeBranch" />
        <p v-else>{{ storeName }}</p>
      </f7-nav-title>
    </f7-navbar>
    <f7-list media-list>
      <f7-list-item title="電子發票" divider />
      <f7-list-item
        :key="`invoice-number-count`"
        :title="`本月剩餘張數: ${invoiceCount ? invoiceCount : 0} 張`" />
    </f7-list>
  </f7-page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NavbarCenter from '@/common/components/NavbarCenter'
import { storeClient } from '@/service/apiClients'

export default {
  data () {
    return {
      invoiceCount: null
    }
  },
  async created () {
    this.setStore(this.storeIdProp)
    const { data } = await storeClient.get(`/stores/${this.storeIdProp}/invoiceNumberCount`)
    this.invoiceCount = data.count
  },
  props: {
    storeIdProp: String
  },
  computed: {
    ...mapGetters([
      'storeId',
      'storeName',
      'storeBranch'
    ])
  },
  components: {
    NavbarCenter
  },
  methods: {
    ...mapActions(['setStore'])
  }
}
</script>

<style lang="scss" scoped>
</style>
